import {
  IonList,
  IonListHeader,
} from '@ionic/react';
import React, { useRef, useEffect } from 'react';
import { Store } from '../models/Store';
import StoreListItem from './StoreListItem';

interface OwnProps {
  stores: Store[];
}

interface StateProps {
}

interface StoreListProps extends OwnProps, StateProps {}

const StoreList: React.FC<StoreListProps> = ({
  stores,
}) => {
  const storeListRef = useRef<HTMLIonListElement>(null);

  useEffect(() => {
    if (storeListRef.current) {
      storeListRef.current.closeSlidingItems();
    }
  }, []);

  if (stores.length === 0) {
    return (
      <IonList>
        <IonListHeader>データがありません。</IonListHeader>
      </IonList>
    );
  }

  return (
    <>
      <IonList ref={storeListRef}>
        {stores.map((record, index: number) => (
          <StoreListItem
            key={`record-${index}`}
            store={record}
          />
        ))}
      </IonList>
    </>
  );
};

export default StoreList;
